import NamePill from '../../../../core/components/molecules/NamePill';
import { Typography } from '../../../../core/components/molecules/Typography';

interface IRankItem {
  score: number;
  name: string;
  position: string;
  profilePhoto?: string;
}

const RankItem: React.FC<IRankItem> = ({
  score,
  name,
  position,
  profilePhoto,
}) => {
  return (
    <div className='flex flex-col items-center gap-lg text-center xs:w-full md:w-[33.3%] xl:w-[20%]'>
      <Typography>{position}</Typography>
      <NamePill profile={profilePhoto} name={name} />
      <Typography type='lead' className='m-auto'>
        {name}
      </Typography>
      <Typography weight='bold'>{score} Pontos</Typography>
    </div>
  );
};

export default RankItem;
